export type ParticularOrderStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
export const ParticularOrderStatus = {
    Nuevo: 0 as ParticularOrderStatus,
    Confirmado: 1 as ParticularOrderStatus,
    Asignado: 2 as ParticularOrderStatus,
    Aceptado: 3 as ParticularOrderStatus,
    Rechazado: 4 as ParticularOrderStatus,
    EnCurso: 5 as ParticularOrderStatus,
    Finalizado: 6 as ParticularOrderStatus,
    Cancelada: 7 as ParticularOrderStatus
};
